import React from 'react';
import ReactMarkdown from 'react-markdown';
import CalendlyButton from './CalendlyButton';
import SuggestionChips from './SuggestionChips';
import './ChatWindow.css';

function ChatWindow({ messages, isLoading, messagesEndRef, showSources, onSuggestionClick, showSuggestions }) {
  return (
    <div className="chat-window">
      <div className="messages-container">
        {messages.map((message, index) => {
          // Check for Calendly button marker
          const hasCalendlyButton = message.text.includes('[CALENDLY_BUTTON]');
          const cleanText = message.text.replace('[CALENDLY_BUTTON]', '').trim();

          // Show suggestions after first bot message (welcome message)
          const isFirstBotMessage = index === 0 && message.type === 'bot';

          return (
            <React.Fragment key={index}>
              <div className={`message ${message.type}`}>
                <div className="message-content">
                  <ReactMarkdown>{cleanText}</ReactMarkdown>

                  {/* Calendly Button (inline in message) */}
                  {hasCalendlyButton && <CalendlyButton />}

                  {/* Sources */}
                  {showSources && message.sources && message.sources.length > 0 && (
                    <div className="sources">
                      <div className="sources-header">
                        <svg className="sources-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <p className="sources-title">Quellen</p>
                      </div>
                      {message.sources.map((source, i) => (
                        <p key={i} className="source-item">{source}</p>
                      ))}
                    </div>
                  )}
                </div>
                <div className="message-timestamp">
                  {message.timestamp.toLocaleTimeString('de-DE', {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </div>
              </div>

              {/* Suggestion Chips after first bot message */}
              {isFirstBotMessage && (
                <SuggestionChips
                  onSuggestionClick={onSuggestionClick}
                  show={showSuggestions}
                />
              )}
            </React.Fragment>
          );
        })}
        {isLoading && (
          <div className="message bot">
            <div className="message-content">
              <div className="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
}

export default ChatWindow;
